//  For each product on the page
(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    const product = JSON.parse(section.querySelector(".productV14JSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".activeVariantJSON").textContent);
    const subscriptionAppID = section.querySelector(".productV14SubscriptionAppID").textContent;
    let quantity = 1;
    const hasSticky = !!section.querySelector(".productV14Sticky");
    const hasMetaImages = !!section.querySelector(".productV14VisualMeta");

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    // function to return the selling_plan_id given a variant ID
    function getSellingPlanID(product, activeVariant) {
        // create an array of selling plans that are accessible for the variant
        const validSellingPlans = [];

        // loop over each group
        for (const group of product.selling_plan_groups) {
            // if the group doesn't match our subscription app ID, skip it
            if (group.app_id !== subscriptionAppID) {
                continue
            }

            // loop through each selling plan in the group
            for (const plan of group.selling_plans) {
                // add the plan ID to the validSellingPlans array
                validSellingPlans.push(plan.id);
            }
        }

        // loop through selling plan allocations of the variant and find the first one that matches a valid selling plan
        for (const allocation of activeVariant.selling_plan_allocations) {
            if (validSellingPlans.includes(allocation.selling_plan_id)) {
                return allocation.selling_plan_id;
            }
        }

        // if no valid selling plan is found, return null
        return null;
    }


    /************
     Product Swipers
     ************/

        // hydrate each wrap's swipers only the first time it becomes visible
    const initializedWraps = new WeakSet();

    function ensureSwipers(element) {
        if (!element || initializedWraps.has(element)) {
            return;
        }
        initializedWraps.add(element);

        const thumbsSwiper = new Swiper(element.querySelector(".productV14VisualThumbs"), {
            slidesPerView: 6,
            spaceBetween: 10,
            loop: true,
            breakpoints: {
                800: {
                    slidesPerView: 6,
                    spaceBetween: 23
                }
            }
        });

        new Swiper(element.querySelector(".productV14VisualSwiper"), {
            slidesPerView: 1,
            spaceBetween: 6,
            loop: true,
            navigation: {
                nextEl: element.querySelector(".productV14VisualSwiperNext"),
                prevEl: element.querySelector(".productV14VisualSwiperPrev"),
            },
            breakpoints: {
                800: {
                    spaceBetween: 23
                }
            },
            thumbs: {
                swiper: thumbsSwiper
            },
            autoHeight: true,
        });
    }

    // only init swipers for the wrap(s) already marked active by liquid
    section.querySelectorAll(".productV14VisualWrap.active").forEach(ensureSwipers);

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct().catch(err => console.log(err));
        });
    })

    /**************
     Update Product
     ***************/

    function isSubscription() {
        return !!document.querySelector(`.productV14SubLabelInput[value="sub"]:checked`);
    }

    // the section's price override wins over the selling plan price
    function subscriptionPrice(allocation) {
        if (section.dataset.subPriceCents) {
            return parseInt(section.dataset.subPriceCents);
        }
        return allocation.price;
    }

    // the section's price override wins over the variant price
    function oneTimePrice() {
        if (section.dataset.otpPriceCents) {
            return parseInt(section.dataset.otpPriceCents);
        }
        return activeVariant.price;
    }

    // prevent images from changing on initial run
    let firstRun = true;

    async function updateProduct() {
        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productV14FormOptionsItemValues`).forEach(group => {

                // disregard sweetener options
                if (!group.classList.contains('sweetener')) {
                    options.push(group.querySelector(`input:checked`).value);
                }
            });


            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelector(".productV14ATC").disabled = true;
            section.querySelector(".productV14ATCText").textContent = "Not Available";
            return;
        }

        // delivery frequency
        section.querySelectorAll(".productV14SubLabelBodyBulletsItemTxt .frequency")?.forEach((item) => {
            item.textContent = "";
        })

        /**************
         Variant Image
         ***************/

        // skip on first load
        if (!firstRun) {
            // check for nutritional label
            if (hasMetaImages) {
                // hide all labels except active variant, if no match, reveal original image
                section.querySelectorAll(`.productV14VisualMeta`).forEach(el => {
                    el.dataset.id === activeVariant.id.toString() ? el.classList.add('active') : el.classList.remove('active');
                })
            }
        }

        /**************
         Price
         ***************/

        let sellingPlanExists = document.querySelector('.productV14SubLabel') || false;

        let sellingPlanID = null;
        let sellingPlan = null;


        // if there's a subscription we need to update both prices
        if (sellingPlanExists) {
            // Select both sets of elements at once
            const compares = section.querySelectorAll(".productV14SubLabelBodyHeaderPriceCompare");
            const reals = section.querySelectorAll(".productV14SubLabelBodyHeaderPriceReal");

            // reset compare
            compares.forEach(item => {
                item.textContent = "";
            });

            // Destructure them for clarity:
            // Assuming the markup is structured so that index 0 is for subscription, index 1 for one-time purchase
            const [subCompare, oneTimeCompare] = compares;
            const [subReal, oneTimeReal] = reals;


            // find the allocation that matches the selling plan ID
            sellingPlanID = getSellingPlanID(product, activeVariant);
            if (sellingPlanID) {
                // find the allocation so we can determine price for this variant
                let allocation = activeVariant.selling_plan_allocations.find(allocation => allocation.selling_plan_id === sellingPlanID);

                // find the selling plan by ID to determine the frequency
                sellingPlan = product.selling_plan_groups.flatMap(group => group.selling_plans).find(plan => plan.id === sellingPlanID);

                const allocationPrice = subscriptionPrice(allocation);

                // Update subscription prices
                if (activeVariant.price > allocationPrice) {
                    subCompare.textContent = price(activeVariant.price, true);
                }
                subReal.textContent = price(allocationPrice, true);

                // Update one-time purchase prices, striking through the higher of compare at and variant price
                const oneTimeRealPrice = oneTimePrice();
                const oneTimeComparePrice = Math.max(activeVariant.compare_at_price || 0, activeVariant.price);
                if (oneTimeComparePrice > oneTimeRealPrice) {
                    oneTimeCompare.textContent = price(oneTimeComparePrice, true);
                }
                oneTimeReal.textContent = price(oneTimeRealPrice, true);


                // delivery frequency
                section.querySelectorAll(".productV14SubLabelBodyBulletsItemTxt .frequency")?.forEach((item) => {
                    item.textContent = sellingPlan.name;
                })
            }
        }

        // update swiper
        let hasDefaultSwiper = document.querySelector('.productV14VisualWrap.default') || false;
        if (hasDefaultSwiper) {

        } else {

            let variant = activeVariant;

            section.querySelector('.productV14VisualWrap.active')?.classList.remove('active');
            const gallerySelector = isSubscription() ? 'sub' : 'once';
            const newActiveWrap = section.querySelector(`.productV14VisualWrap.${gallerySelector}[data-id='${variant.id}']`);
            if (newActiveWrap) {
                newActiveWrap.classList.add('active');
                ensureSwipers(newActiveWrap);
            }
        }

        // shipping text
        document.querySelectorAll('.productV14IconsItem')?.forEach(item => {
            // if there is a .productIconsItemTxt.sub, check if we're subscribed
            if (item.querySelector('.productV14IconsItemTxt.sub')) {
                if (isSubscription()) {
                    item.querySelector('.productV14IconsItemTxt.sub').classList.add('active');
                    item.querySelector('.productV14IconsItemTxt.once').classList.remove('active');
                } else {
                    item.querySelector('.productV14IconsItemTxt.sub').classList.remove('active');
                    item.querySelector('.productV14IconsItemTxt.once').classList.add('active');

                }
            }
        })


        // update price
        section.querySelector(".productV14ATCPrice").textContent = price(oneTimePrice(), true);
        if (isSubscription()) {
            let sellingPlanID = getSellingPlanID(product, activeVariant);
            if (sellingPlanID) {
                let allocation = activeVariant.selling_plan_allocations.find(allocation => allocation.selling_plan_id === sellingPlanID);
                section.querySelector(".productV14ATCPrice").textContent = price(subscriptionPrice(allocation), true);
            }
        }

        /**************
         ATC Enable/Disable
         ***************/

        // selling plan check
        if (sellingPlanExists && !sellingPlan && isSubscription()) {
            section.querySelector(".productV14ATC").disabled = true;
            section.querySelector(".productV14ATCText").textContent = "Subscription Unavailable";
        }

        // check if the variant is in stock
        else if (activeVariant.available) {
            section.querySelector(".productV14ATC").disabled = false;
            section.querySelector(".productV14ATCText").textContent = "Add To Cart";
        } else {
            section.querySelector(".productV14ATC").disabled = true;
            section.querySelector(".productV14ATCText").textContent = "Sold Out";
        }


        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct().catch(err => console.log(err));
    firstRun = false;

    /**************
     Delivery time
     ***************/
    let deliveryExists = section.querySelector(".productV14Shipping") || false;
    if (deliveryExists) {
        // get cutoff time (0-24 hour)
        let cutoff = parseInt(section.querySelector(".productV14Shipping").dataset.cutoff);
        // get current time
        let now = new Date();
        let hours = now.getHours();
        let minutes = now.getMinutes();
        let seconds = now.getSeconds();

        // get time until next cutoff
        let timeUntilCutoff = (cutoff - hours) * 60 * 60 - (minutes * 60 + seconds);
        if (timeUntilCutoff < 0) {
            timeUntilCutoff += 24 * 60 * 60;
        }
        // convert to hours, minutes, seconds
        let hoursUntilCutoff = Math.floor(timeUntilCutoff / 3600);
        let minutesUntilCutoff = Math.floor((timeUntilCutoff % 3600) / 60);

        // update text (x hrs x mins)
        section.querySelector('.productV14ShippingOrderCutoff').textContent = `${hoursUntilCutoff} hrs ${minutesUntilCutoff} mins`;

        // update text every second
        setInterval(() => {
            // get current time
            now = new Date();
            hours = now.getHours();
            minutes = now.getMinutes();
            seconds = now.getSeconds();

            // get time until next cutoff
            timeUntilCutoff = (cutoff - hours) * 60 * 60 - (minutes * 60 + seconds);
            if (timeUntilCutoff < 0) {
                timeUntilCutoff += 24 * 60 * 60;
            }
            // convert to hours, minutes, seconds
            hoursUntilCutoff = Math.floor(timeUntilCutoff / 3600);
            minutesUntilCutoff = Math.floor((timeUntilCutoff % 3600) / 60);

            // update text (x hrs x mins)
            section.querySelector('.productV14ShippingOrderCutoff').textContent = `${hoursUntilCutoff} hrs ${minutesUntilCutoff} mins`;

        }, 1000);
    }


    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // add loading animation to both buttons
        section.querySelector(".productV14ATC").classList.add("loading");
        if (hasSticky) section.querySelector(".productV14StickyATC").classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // check for selling plan
        if (isSubscription()) {
            formData.items[0].selling_plan = getSellingPlanID(product, activeVariant);
            // add gift if available
            if (gifts && gifts.length > 0) {
                // update cart to check items, do not add if already in cart
                cart = await getCart();
                for (let gift of gifts) {
                    // check if in cart
                    if (!cart.items.find(item => item.variant_id === gift)) {
                        formData.items.push({
                            quantity: 1,
                            id: gift,
                        })
                    }
                }
            }
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productV14ATC").classList.remove("loading");
        if (hasSticky) section.querySelector(".productV14StickyATC").classList.remove("loading");

    }

    section.querySelector('.productV14ATC').addEventListener("click", addToCart);

    // LP pages scroll to product links
    document.querySelectorAll(`a[href="#product"]`)?.forEach(link => {
        link.addEventListener("click", (e) => {
            e.preventDefault();
            section.scrollIntoView({behavior: "smooth"});
        })
    })

})();
